



































import { Vue, Component, Prop } from 'vue-property-decorator';
import { GroupingAnswer } from "./grouping-interfaces";
import { GroupingCorrectAnswer } from './grouping-question-component.vue'
import i18n from '@/plugins/i18n';
import * as Api from "@/app/question/components/api";

interface Group {
  label: string;
  userMembers: Member[];
  correctMembers: string[];
}

interface Member {
  correct: boolean;
  label: string;
}

@Component
export default class GroupingQuestionSolutionComponent extends Vue
  implements Api.QuestionSolutionProps2<GroupingAnswer, GroupingCorrectAnswer> {

  @Prop()
  public userAnswer: GroupingAnswer;

  @Prop()
  public correctAnswer: GroupingCorrectAnswer;

  private get groups(): Group[] {
    let groups: Group[] = [];
    this.correctAnswer.groups.forEach((g) => {
      const answeredMemberIds: string[] = this.userAnswer.groupMembers[g.id] || [];
      groups =  [...groups, {
        label: g.label,
        userMembers: this.getUserMembers(answeredMemberIds, g.id),
        correctMembers: g.members.map((m) => m.text)
      }];
    });

    return groups;
  }

  private getUserMembers(memberIds: string[], groupId: string): Member[] {
    let members: Member[] = [];
    for (const group of this.correctAnswer.groups) {
      for (const member of group.members) {
        if (memberIds.includes(member.id)) {
          members = [...members, {
            label: member.text,
            correct: groupId === group.id
          }];
        }
      }
    }

    return members;
  }

  private t(key: string, params: any = {}) {
    return i18n.t(key, params);
  }
}
